// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jg_a bhp_a bhp_j bhp_q bhp_sv bhp_sw bhp_w"};